import React from "react";

import { PageHeader, PageMain } from "components/molecules";
import {
  TanTable,
  TanTableColumn,
  usePagination,
  useSorting,
} from "components/molecules";
import { routes } from "consts";
import { useNavigate } from "react-router-dom";
import { useCategoryTree, FlattenedCategory, flattenTree } from "api/categories";

export const CategoriesPage = (): JSX.Element => {
  const navigate = useNavigate();
  const { onPaginationChange, pagination } = usePagination();
  const { sorting, onSortingChange } = useSorting();
  const { isLoading, isFetching, tree } = useCategoryTree();

  const flatCategories = React.useMemo(() => flattenTree(tree), [tree]);

  const columns = React.useMemo<TanTableColumn<FlattenedCategory>[]>(
    () => [
      {
        id: "id",
        header: "ID",
        accessorKey: "id",
        enableColumnFilter: false,
        size: 10,
      },
      {
        id: "name",
        header: "Nazwa",
        accessorFn: (row) => row.name,
        enableColumnFilter: false,
        cell: ({ row }) => (
          <span style={{ paddingLeft: `${row.original.depth * 24}px` }}>
            {row.original.depth > 0 && <span className="mr-1 text-gray-400">└</span>}
            {row.original.name}
          </span>
        ),
      },
      {
        id: "parentName",
        header: "Kategoria nadrzędna",
        accessorFn: (row) => row.parentName ?? "-",
        enableColumnFilter: false,
      },
      {
        id: "slug",
        header: "Slug",
        accessorFn: (row) => row.slug,
        enableColumnFilter: false,
      },
    ],
    [],
  );

  return (
    <PageMain>
      <PageHeader
        button={{
          title: "Dodaj +",
          onClick: () => navigate(routes.COURSES_CATEGORIES_ADD),
        }}
      >
        Kategorie
      </PageHeader>
      <TanTable
        data={flatCategories}
        columns={columns}
        loading={isLoading}
        fetching={isFetching}
        total={flatCategories.length}
        onPaginationChange={onPaginationChange}
        onSortingChange={onSortingChange}
        pagination={pagination}
        sorting={sorting}
        onRowClick={(row) => navigate(routes.COURSES_CATEGORIES_EDIT(row.id))}
      />
    </PageMain>
  );
};
